import React from 'react';

const Awards = () => {
  <h3>Awards</h3>;
};

export default Awards;
